import React, { useEffect } from "react";
import { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import useHashArray from "../../../../hooks/useHashArray";
import {
  getLandingPagesActionHandler,
  getNotificationEventActionHandler,
  getNotificationEventValuesActionHandler,
  getNotificationFrequencyActionHandler,
  getNotificationModeActionHandler,
  getNotificationPlaceholdersActionHandler,
  getNotificationTemplateActionHandler,
  getNotificationTypeActionHandler,
  getPlaceHolderEventsActionHandler,
  getPlaceholderEventValuesActionHandler,
  updateNotificationActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/engagementCenterActionHandler";
import { engagementCenter } from "../../../../utils/mainTabs/admin/engagementCenter/engagementCenter";
import { notificationDetails } from "../../../../utils/mainTabs/admin/engagementCenter/notificationDetails";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import ToggleButton from "../../../Common/ToggleButton/ToggleButton";
import MobileImage from "../../../../assets/images/Manage/Mobile.png";
import classes from "./NotificationDetailsForm.module.scss";
import getTenantName from "../../../../utils/getTenantName";
import { FormattedMessage } from "react-intl";

const NotificationDetailsForm = ({ formValues }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tenantName = getTenantName(dispatch, location);

  const { heading, formFields } = notificationDetails;
  const engagementCenterPath = engagementCenter.path(tenantName);
  const headingText = heading(location);

  const [templateDetailsFields, setTemplateDetailsFields] = useState([]);
  const [generalSettingsFields, setGeneralSettingsFields] = useState([]);
  const [notificationOccurrenceFields, setNotificationOccurrenceFields] =
    useState([]);
  const [messageTemplateFields, setMessageTemplateFields] = useState([]);
  const [isActive, setIsActive] = useState(formValues?.IsActive);
  const [notificationModeList, setNotificationModeList] = useState([]);
  const [notificationTemplateList, setNotificationTemplateList] = useState([]);
  const [notificationTypeList, setNotificationTypeList] = useState([]);
  const [notificationFrequencyList, setNotificationFrequencyList] = useState(
    []
  );
  const [notificationPlaceHolderList, setNotificationPlaceHolderList] =
    useState([]);
  const [placeHolderEventList, setplaceHolderEventList] = useState([]);
  const [notificationEventList, setNotificationEventList] = useState([]);
  const [notificationEventValueList, setNotificationEventValueList] = useState(
    []
  );
  const [
    notificationPlaceholderValueList,
    setNotificationPlaceholderValueList,
  ] = useState([]);
  const [landingPageList, setLandingPageList] = useState([]);

  const [
    selectedNotificationEventValueList,
    setSelectedNotificationEventValueList,
  ] = useState([]);
  const [
    selectedNotificationPlaceholderValueList,
    setSelectedNotificationPlaceholderValueList,
  ] = useState([]);

  useEffect(() => {
    dispatch(getNotificationModeActionHandler()).then(
      (notificationModeList) => {
        setNotificationModeList(notificationModeList);
      }
    );
    dispatch(getNotificationTemplateActionHandler()).then(
      (notificationTemplateList) => {
        setNotificationTemplateList(notificationTemplateList);
      }
    );
    dispatch(getNotificationTypeActionHandler()).then(
      (notificationTypeList) => {
        setNotificationTypeList(notificationTypeList);
      }
    );
    dispatch(getNotificationFrequencyActionHandler()).then(
      (notificationFrequencyList) => {
        setNotificationFrequencyList(notificationFrequencyList);
      }
    );
    dispatch(getNotificationPlaceholdersActionHandler()).then(
      (notificationPlaceHolderList) => {
        setNotificationPlaceHolderList(notificationPlaceHolderList);
      }
    );
    dispatch(getPlaceHolderEventsActionHandler()).then(
      (placeHolderEventList) => {
        setplaceHolderEventList(placeHolderEventList);
      }
    );

    dispatch(getLandingPagesActionHandler()).then((landingPageList) => {
      setLandingPageList(landingPageList);
    });
  }, [dispatch]);

  const methods = useForm({
    mode: "onChange",
    defaultValues: formValues,
    // resolver: yupResolver(notificationHistorySchema),
  });
  const {
    handleSubmit,
    formState: { errors, isValid },
    reset,
    setValue,
    setFocus,
    getValues,
    watch,
  } = methods;

  const shortMessage = watch("ShortMessage");
  const longMessage = watch("Message");

  useEffect(() => {
    const landingPageListItem = landingPageList?.find(
      (page) => page?.Id === formValues?.LandingPageId
    );

    const handleClickPlaceHolderTag = (tag) => {
      const messageValue = getValues("Message");
      const updateMEssageValue = `${messageValue} ${tag.PlaceHolderName} `;
      setValue("Message", updateMEssageValue);
      setFocus("Message");
    };
    if ((landingPageListItem, formValues?.NotificationTypeId)) {
      const formArgs = {
        notificationModeList,
        notificationTemplateList,
        notificationTypeList,
        notificationFrequencyList,
        notificationPlaceHolderList,
        notificationPlaceholderValueList,
        setNotificationPlaceholderValueList,
        notificationEventList,
        notificationEventValueList,
        setNotificationEventValueList,
        landingPageListItem,
        handleClickPlaceHolderTag,
        formValues,
      };
      const inputFields = formFields(formArgs);
      setTemplateDetailsFields(inputFields.templateDetailsFields);
      setGeneralSettingsFields(inputFields.generalSettingsFields);
      setNotificationOccurrenceFields(inputFields.notificationOccurrenceFields);
      setMessageTemplateFields(inputFields.messageTemplateFields);
    }
  }, [
    formFields,
    formValues,
    getValues,
    setFocus,
    setValue,
    notificationModeList,
    notificationTemplateList,
    notificationTypeList,
    notificationFrequencyList,
    notificationPlaceHolderList,
    notificationPlaceholderValueList,
    notificationEventList,
    notificationEventValueList,
    landingPageList,
  ]);

  useEffect(() => {
    if (formValues) {
      setSelectedNotificationEventValueList(
        formValues?.NotificationTypeId === 1
          ? [{ Key: formValues?.EventValueId, Value: formValues?.EventValue }]
          : formValues?.EventValues
      );
      setSelectedNotificationPlaceholderValueList(
        formValues?.NotificationTypeId === 1
          ? [
              {
                Key: formValues?.PlaceHolderEventValueId,
                Value: formValues?.PlaceHolderEventValue,
              },
            ]
          : []
      );
    }
  }, [formValues]);

  const { hashTable: eventValuesHashTable } = useHashArray(
    selectedNotificationEventValueList,
    "Key",
    true
  );
  const { hashTable: placeHolderValuesHashTable } = useHashArray(
    selectedNotificationPlaceholderValueList,
    "Key",
    true
  );

  useEffect(() => {
    if (
      formValues?.NotificationTypeId &&
      eventValuesHashTable &&
      placeHolderValuesHashTable
    ) {
      if (formValues.NotificationTypeId !== 1) {
        dispatch(
          getNotificationEventValuesActionHandler(formValues.EventTypeId)
        ).then((notificationEventValueList) => {
          // if (formValues?.NotificationTypeId === 1) {
          //   setValue("eventValues", [
          //     { Key: formValues?.EventValueId, Value: formValues?.EventValue },
          //   ]);
          // }
          const updatedList = notificationEventValueList?.map((value) => {
            return eventValuesHashTable[value?.Key]
              ? { ...value, checked: true }
              : { ...value, checked: false };
          });
          setNotificationEventValueList(updatedList);
        });
      } else {
        dispatch(
          getPlaceholderEventValuesActionHandler(formValues.PlaceHolderEventId)
        ).then((placeholderEventValueList) => {
          const updatedList = placeholderEventValueList?.map((value) => {
            return placeHolderValuesHashTable[value?.Key]
              ? { ...value, checked: true }
              : { ...value, checked: false };
          });
          const updatedList2 = placeholderEventValueList?.map((value) => {
            return eventValuesHashTable[value?.Key]
              ? { ...value, checked: true }
              : { ...value, checked: false };
          });
          setNotificationEventValueList(updatedList2);
          setNotificationPlaceholderValueList(updatedList);
        });
      }
    }
  }, [formValues, dispatch, eventValuesHashTable, placeHolderValuesHashTable]);

  useEffect(() => {
    if (formValues?.NotificationTypeId) {
      reset({ ...formValues, IsEventBase: formValues?.IsEventBase.toString() });
      setIsActive(formValues?.IsActive);
      dispatch(
        getNotificationEventActionHandler(formValues?.NotificationTypeId)
      ).then((notificationEventList) => {
        setNotificationEventList(notificationEventList);
      });
    }
  }, [reset, dispatch, formValues]);

  const onSubmit = (data) => {
    const {
      TagSearch,
      ClickToAction,
      PlaceHolderEventValues,
      IsEventBase,
      IsActive,
      PlaceHolderList,
      StartDateAndTime,
      Timezones,
      ...otherData
    } = data;
    if (formValues.NotificationTypeId === 1) {
      const formData = {
        ...otherData,
        IsActive: isActive,
        EventValueId: data.EventValues[0]?.Key,
        EventValue: data.EventValues[0]?.Value,
        EventValues: [],
        PlaceHolderEventValueId: PlaceHolderEventValues[0]?.Key,
        PlaceHolderEventValue: PlaceHolderEventValues[0]?.Value,
        IsEventBase: IsEventBase === "true" ? true : false,
      };
      dispatch(updateNotificationActionHandler(formData)).then(() => {
        navigate(engagementCenterPath);
      });
    } else if (formValues.NotificationTypeId === 2) {
      const dateTimeToLocale = new Date(StartDateAndTime)
        .toLocaleString()
        .replace(/(.*)\D\d+/, "$1");
      const formData = {
        ...otherData,
        IsActive: isActive,
        FormattedNotifyIn: dateTimeToLocale + " " + Timezones,
        IsEventBase: IsEventBase === "true" ? true : false,
      };
      dispatch(updateNotificationActionHandler(formData)).then(() => {
        navigate(engagementCenterPath);
      });
    } else if (formValues.NotificationTypeId === 3) {
      const formData = {
        ...otherData,
        IsActive: isActive,
        IsEventBase: IsEventBase === "true" ? true : false,
      };
      dispatch(updateNotificationActionHandler(formData)).then(() => {
        navigate(engagementCenterPath);
      });
    }
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.notificationDetailsForm}
      >
        <div className={classes.notificationDetailsForm__header}>
          <div className={classes.notificationDetailsForm__header__title}>
            {headingText}
          </div>
        </div>
        <div className={classes.notificationDetailsForm__templateDetailsFields}>
          {templateDetailsFields?.map((field) => {
            return (
              <div
                key={field?.key}
                className={
                  classes.notificationDetailsForm__templateDetailsFields__field
                }
              >
                <Input
                  label={field?.label}
                  name={field?.name}
                  type={field?.type}
                  fieldName={field?.fieldName}
                  fieldValue={field?.fieldValue}
                  valueArr={field?.valueArr}
                  searchTagsList={field?.searchTagsList}
                  hidden={field?.hidden}
                  placeholder={field?.placeholder}
                  labelColor={field?.labelColor}
                  labelMsg={field?.labelMsg}
                  width={field?.width}
                  disabled={field?.disabled}
                  required={field?.required}
                  widthType={field?.widthType}
                  error={errors?.[field?.name]?.message}
                />
              </div>
            );
          })}
          {formValues?.NotificationTypeId === 2 && (
            <div
              className={
                classes.notificationDetailsForm__templateDetailsFields__category
              }
            >
              Category
              <div
                className={
                  classes.notificationDetailsForm__templateDetailsFields__category__inputGroup
                }
              >
                <Input
                  label="Event Based"
                  fieldName="Event Based"
                  name="IsEventBase"
                  type="radio"
                  width="100"
                  widthType="%"
                  height="2"
                  value={true}
                  direction="row-reverse"
                  disabled
                />
                <Input
                  label="General"
                  fieldName="General"
                  name="IsEventBase"
                  type="radio"
                  width="100"
                  widthType="%"
                  height="2"
                  value={false}
                  direction="row-reverse"
                  disabled
                />
              </div>
            </div>
          )}
          <div
            className={
              classes.notificationDetailsForm__templateDetailsFields__status
            }
          >
            Is Active
            <ToggleButton
              enable={isActive}
              leftText=" "
              rightText=" "
              handleClick={() => setIsActive(!isActive)}
            />
          </div>
        </div>
        <div className={classes.notificationDetailsForm__generalSettingsFields}>
          {generalSettingsFields?.map((field) => {
            return (
              <div
                key={field?.key}
                className={
                  classes.notificationDetailsForm__generalSettingsFields__field
                }
              >
                <Input
                  label={field?.label}
                  name={field?.name}
                  type={field?.type}
                  tagType={field?.tagType}
                  fieldName={field?.fieldName}
                  fieldValue={field?.fieldValue}
                  valueArr={field?.valueArr}
                  searchTagsList={field?.searchTagsList}
                  handleTagList={field?.handleTagList}
                  hidden={field?.hidden}
                  placeholder={field?.placeholder}
                  labelColor={field?.labelColor}
                  labelMsg={field?.labelMsg}
                  width={field?.width}
                  disabled={field?.disabled}
                  isTagCheckBoxVisible={field?.isTagCheckBoxVisible}
                  required={field?.required}
                  widthType={field?.widthType}
                  error={errors?.[field?.name]?.message}
                />
              </div>
            );
          })}
        </div>
        {formValues?.NotificationTypeId === 2 && (
          <div
            className={
              classes.notificationDetailsForm__notificationOccurrenceFields
            }
          >
            {notificationOccurrenceFields?.map((field) => {
              const formatmindatetime = new Date(
                new Date().toString().split("GMT")[0] + " UTC"
              )
                .toISOString()
                .split(".")[0]
                .split(":");
              formatmindatetime.pop();
              const mindatetime = formatmindatetime.join(":");

              return (
                <div
                  key={field?.key}
                  className={
                    classes.notificationDetailsForm__notificationOccurrenceFields__field
                  }
                >
                  <Input
                    label={field?.label}
                    name={field?.name}
                    type={field?.type}
                    fieldName={field?.fieldName}
                    fieldValue={field?.fieldValue}
                    valueArr={field?.valueArr}
                    searchTagsList={field?.searchTagsList}
                    hidden={field?.hidden}
                    placeholder={field?.placeholder}
                    labelColor={field?.labelColor}
                    labelMsg={field?.labelMsg}
                    width={field?.width}
                    min={field?.type === "datetime-local" && mindatetime}
                    disabled={field?.disabled}
                    widthType={field?.widthType}
                    error={errors?.[field?.name]?.message}
                  />
                </div>
              );
            })}
          </div>
        )}
        <div className={classes.notificationDetailsForm__messageTemplateFields}>
          {messageTemplateFields?.map((field) => {
            if (!field?.isHidden) {
              return (
                <div
                  key={field?.key}
                  className={
                    classes.notificationDetailsForm__messageTemplateFields__field
                  }
                >
                  <Input
                    label={field?.label}
                    name={field?.name}
                    type={field?.type}
                    fieldName={field?.fieldName}
                    fieldValue={field?.fieldValue}
                    valueArr={field?.valueArr}
                    searchTagsList={field?.searchTagsList}
                    hidden={field?.hidden}
                    placeholder={field?.placeholder}
                    labelColor={field?.labelColor}
                    labelMsg={field?.labelMsg}
                    width={field?.width}
                    disabled={field?.disabled}
                    widthType={field?.widthType}
                    addedTagsVisible={field?.addedTagsVisible}
                    isTagCheckBoxVisible={field?.isTagCheckBoxVisible}
                    handleClickTag={field?.handleClickTag}
                    required={field?.required}
                    error={errors?.[field?.name]?.message}
                  />
                </div>
              );
            } else {
              return <React.Fragment key={field?.key}></React.Fragment>;
            }
          })}
          {formValues?.NotificationTypeId === 2 && (
            <div
              className={
                classes.notificationDetailsForm__messageTemplateFields__preview
              }
            >
              <img
                src={MobileImage}
                alt="preview"
                className={
                  classes.notificationDetailsForm__messageTemplateFields__preview__image
                }
              />
              <div
                className={
                  classes.notificationDetailsForm__messageTemplateFields__preview__container
                }
              >
                <div
                  className={
                    classes.notificationDetailsForm__messageTemplateFields__preview__container__details
                  }
                >
                  <div
                    className={
                      classes.notificationDetailsForm__messageTemplateFields__preview__container__details__messages
                    }
                  >
                    <div
                      className={
                        classes.notificationDetailsForm__messageTemplateFields__preview__container__details__messages__shortMessage
                      }
                    >
                      {shortMessage}
                    </div>
                    {longMessage}
                  </div>
                  <Button label="Button" dark height="4" width="12" />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className={classes.notificationDetailsForm__footer}>
          <div
            className={classes.notificationDetailsForm__footer__inputContainer}
          >
            <Input
              label={<FormattedMessage id="CLICK_TO_ACTION" />}
              name={
                formValues?.NotificationTypeId === 1
                  ? "PlaceHolderEventId"
                  : "ClickToAction"
              }
              type="select"
              fieldName="Name"
              fieldValue="Id"
              placeholder="Select Action"
              labelColor="light"
              valueArr={placeHolderEventList}
              disabled={true}
              width={25}
              error={errors?.["ClickToAction"]?.message}
            />
            {formValues?.NotificationTypeId === 1 && (
              <Input
                label={<FormattedMessage id="CLICK_TO_ACTION_VALUES" />}
                name="PlaceHolderEventValues"
                fieldName="Value"
                fieldValue="Key"
                type="noSearchTags"
                tagType="single"
                placeholder="Select Action Value"
                searchTagsList={notificationPlaceholderValueList}
                labelColor="light"
                width={25}
                isTagCheckBoxVisible={false}
                error={errors?.["PlaceHolderEventValues"]?.message}
              />
            )}
          </div>
          <Button label={<FormattedMessage id="P_SAVE_TXT" />} small dark type="submit" disabled={!isValid} />
        </div>
      </form>
    </FormProvider>
  );
};

export default NotificationDetailsForm;

